import React from "react";
import { Button, Stack } from "@mui/material";
import { useIntl } from "react-intl";
import { DASHBOARD_MODES } from "constants/dashboard-mode";
import { useDashboardMode } from "hooks/useDashboardMode";

const MODE_LABELS = {
  [DASHBOARD_MODES.GESTION]: "dashboard.mode.gestion",
  [DASHBOARD_MODES.ORG]: "dashboard.mode.org",
  [DASHBOARD_MODES.MINE]: "dashboard.mode.mine",
};

const DashboardModeSwitcher = () => {
  const intl = useIntl();
  const { mode, available, selectMode, showSwitcher } = useDashboardMode();

  if (!showSwitcher) return null;

  return (
    <Stack direction="row" spacing={0.5} sx={{ mr: 1, flexWrap: "wrap", justifyContent: "flex-end" }}>
      {available.map((item) => (
        <Button
          key={item}
          size="small"
          color={mode === item ? "secondary" : "inherit"}
          variant={mode === item ? "contained" : "text"}
          onClick={() => selectMode(item)}
        >
          {intl.formatMessage({ id: MODE_LABELS[item] })}
        </Button>
      ))}
    </Stack>
  );
};

export default DashboardModeSwitcher;
